import { useMutation, useQueryClient } from 'react-query'
import { PROFILE_QUERY_KEY } from '@entities/user'
import { setNextPlan, type NextPlanPayload } from '../api/subscriptionApi'

/**
 * Отложенная смена тарифа.
 *
 * После успеха перечитываем профиль: выбранный тариф приезжает оттуда полем
 * `next_subscription_info_id`, и без инвалидации отметка в подписке осталась
 * бы от прошлого ответа.
 */
export const useSetNextPlanMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, NextPlanPayload>(setNextPlan, {
    onSuccess: () => {
      queryClient.invalidateQueries(PROFILE_QUERY_KEY)
    },
  })
}
